import { useState } from 'react'
import { useFirefly } from '../../../../resources/useAnalytics'

export const useQuickSearch = () => {
  const [activeFilterTab, setFilterTab] = useState('all-filters')
  const { handleTrackEvent } = useFirefly()
  const onTabSelect = (event, tab) => {
    setFilterTab(tab.name)
    handleTrackEvent('Filter Tab', event)
  }

  return {
    onTabSelect,
    activeFilterTab,
  }
}
